/**
 * Search param của trang quy tắc — chỉ dùng để nhận prefill từ nơi khác
 * ("Tạo quy tắc từ giao dịch này" trên hàng đợi đồng bộ), không giữ trạng
 * thái lọc/trang của trang này.
 */
export interface ExpenseRuleSearch {
    prefill_field?: 'content' | 'counterparty' | 'account'
    prefill_keyword?: string
    prefill_category_id?: string
}

const VALID_FIELDS = new Set(['content', 'counterparty', 'account'])

export function normalizeExpenseRuleSearch(
    search: Record<string, unknown>,
): ExpenseRuleSearch {
    const out: ExpenseRuleSearch = {}
    const field = search.prefill_field
    const keyword = search.prefill_keyword
    if (
        typeof field === 'string' &&
        VALID_FIELDS.has(field) &&
        typeof keyword === 'string' &&
        keyword.trim() !== ''
    ) {
        out.prefill_field = field as ExpenseRuleSearch['prefill_field']
        out.prefill_keyword = keyword
    }
    const categoryId = search.prefill_category_id
    if (typeof categoryId === 'string' && categoryId.trim() !== '') {
        out.prefill_category_id = categoryId
    }
    return out
}
